import { isTag } from "domhandler";
import React from "react";

import ContentLink from "../../text/ContentLink";

import { HtmlToReactProcessor } from "./processor";

const ProcessLinks: HtmlToReactProcessor = (
  node,
  _children,
  _index,
  defaultProcessor,
) => {
  if (!isTag(node) || node.name !== "a") return;
  if (!node.attribs.href) return;

  const defaultResult = defaultProcessor();
  if (defaultResult === false) {
    // This only happens for comment nodes, so we'll actually never get here
    return undefined;
  }

  return <ContentLink {...defaultResult.props} />;
};

export default ProcessLinks;
